import React from 'react'

export default [
  {
    title: '活动名称',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: '报名时间',
    dataIndex: 'time',
    key: 'time',
    render: (time, { publish_time, sign_up_end_time }) => (
      <div>
        <p>从 {publish_time.split(' ')[0]}</p>
        <p>至 {sign_up_end_time.split(' ')[0]}</p>
      </div>
    )
  },
  {
    title: '上线时间',
    dataIndex: 'publish_time',
    key: 'publish_time',
    render: publish_time => <p>{publish_time}</p>
  },
  {
    title: '操作',
    dataIndex: 'link',
    key: 'link',
    render: link => <a href={link}>活动页面预览</a>
  }
]
